import { gunterzBlack } from '@/theme/fonts';
import { Group, Image, type MantineSpacing, type StyleProp, Text } from '@mantine/core';
export type CardTitleProps = {
  firstText: string;
  secondText?: string;
  iconUrl?: string;
  isFirstGradient?: boolean;
  isSecondGradient?: boolean;
  colorFrom?: string;
  colorTo?: string;
  mt?: StyleProp<MantineSpacing>;
};
export const CardTitle: React.FC<CardTitleProps> = ({
  firstText,
  secondText,
  iconUrl,
  isFirstGradient,
  isSecondGradient,
  colorFrom,
  colorTo,
  mt
}) => {
  return <Group align="center" gap={4} wrap="nowrap">
      <Text mt={mt} fw={700} py={4} fz={{
      base: 13,
      md: 18
    }} c="var(--text-white)" className={gunterzBlack.className} style={{
      textWrap: 'nowrap'
    }}>
        <Text span inherit variant={isFirstGradient ? 'gradient' : 'text'} gradient={{
        from: `${colorFrom} 10%`,
        to: ` ${colorTo} 90%`,
        deg: 135
      }}>
          {firstText}
        </Text>{' '}
        <Text span inherit variant={isSecondGradient ? 'gradient' : 'text'} gradient={{
        from: `${colorFrom} 10%`,
        to: `${colorTo} 90%`,
        deg: 135
      }}>
          {secondText}
        </Text>
      </Text>
      {iconUrl && <Image src={iconUrl} alt="card-title" w={{
      base: 30,
      md: 40
    }} h={{
      base: 30,
      md: 40
    }} />}
    </Group>;
};